module.exports = __webpack_public_path__ + "img/dver_metall.4fe647dc.svg";